import React from 'react';
import { Link } from 'react-router-dom';

const SalaTakatifuPrivacyPage = () => {
  const lastUpdated = 'Mei 2026 / May 2026';

  return (
    <div className="min-h-screen bg-black text-gray-300">
      {/* Header */}
      <div className="bg-gradient-to-b from-secondary-500/10 to-transparent pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/" className="text-secondary-400 hover:text-secondary-300 text-sm mb-4 inline-flex items-center gap-2">
            ← Back to Home
          </Link>
          <div className="flex items-center gap-4 mt-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-secondary-500/30 to-secondary-600/10 border border-secondary-500/20 flex items-center justify-center text-2xl">
              🕊️
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-gaming font-bold text-white">
                Sala Takatifu
              </h1>
              <p className="text-secondary-400 text-sm mt-1 font-medium">Sera ya Faragha / Privacy Policy</p>
            </div>
          </div>
          <p className="text-gray-500 mt-5 text-sm">
            Imesasishwa / Last updated: <span className="text-gray-400">{lastUpdated}</span>
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pb-24">
        <div className="prose prose-invert prose-lg max-w-none">

          {/* App badge */}
          <div className="mb-10 flex flex-wrap gap-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-green-500/10 text-green-400 border border-green-500/20">
              ✓ Hakuna data ya kibinafsi / No personal data
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-blue-500/10 text-blue-400 border border-blue-500/20">
              📵 Inafanya kazi bila intaneti / Offline capable
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-purple-500/10 text-purple-400 border border-purple-500/20">
              💾 Hifadhi ya ndani tu / Local storage only
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-yellow-500/10 text-yellow-400 border border-yellow-500/20">
              📢 Matangazo / Contains ads
            </span>
          </div>

          {/* 1. Introduction */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">1. Utangulizi / Introduction</h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 space-y-3">
              <p className="text-sm leading-relaxed">
                Sala Takatifu ("sisi", "yetu") ni programu ya sala za Kikatoliki kwa Kiswahili.
                Sera hii inaeleza jinsi tunavyoshughulikia taarifa zako.
              </p>
              <p className="text-gray-400 text-sm leading-relaxed border-t border-white/10 pt-3">
                Sala Takatifu ("we", "our") is a Swahili Catholic prayer app. This policy explains
                how we handle your information.
              </p>
            </div>
          </section>

          {/* 2. Information We Collect */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              2. Taarifa Tunazokusanya / Information We Collect
            </h2>

            <div className="bg-white/5 rounded-xl p-6 border border-white/10 mb-4">
              <p className="font-semibold text-white mb-1">
                Hatukusanyi taarifa za kibinafsi.
              </p>
              <p className="text-sm mb-4">
                Programu hii haihitaji akaunti, jina, barua pepe, au nambari ya simu.
              </p>
              <p className="font-semibold text-white mb-1">
                We do not collect personal information.
              </p>
              <p className="text-sm text-gray-400">
                This app does not require an account, name, email, or phone number.
              </p>
            </div>

            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <p className="text-sm font-semibold text-white mb-3">
                Taarifa zinazohifadhiwa kwenye kifaa chako pekee / Data stored locally on your device only:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-secondary-400 mt-0.5">✓</span>
                  <div>
                    <p className="text-sm text-white">Maendeleo ya novena (siku uliyofikia)</p>
                    <p className="text-xs text-gray-500">Novena progress (which day you're on)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-secondary-400 mt-0.5">✓</span>
                  <div>
                    <p className="text-sm text-white">Mipangilio ya programu (mandhari ya giza/mwanga)</p>
                    <p className="text-xs text-gray-500">App settings (dark/light theme)</p>
                  </div>
                </li>
              </ul>
              <p className="mt-4 text-xs text-gray-500 border-t border-white/10 pt-3">
                This data never leaves your device.
              </p>
            </div>
          </section>

          {/* 3. Advertising */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              3. Matangazo / Advertising
            </h2>
            <p className="mb-4 text-sm">
              Tunatumia Google AdMob kuonyesha matangazo. / We use Google AdMob to display advertisements.
            </p>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <h4 className="text-white font-bold mb-3">Google AdMob</h4>
              <p className="text-sm mb-4">Google inaweza kukusanya / Google may collect:</p>
              <ul className="space-y-2">
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 mt-0.5">•</span>
                  <div>
                    <p className="text-sm text-white">Kitambulisho cha matangazo (Advertising ID)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 mt-0.5">•</span>
                  <div>
                    <p className="text-sm text-white">Taarifa za kifaa (aina ya kifaa, mfumo wa uendeshaji)</p>
                    <p className="text-xs text-gray-500">Device information (device type, operating system)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 mt-0.5">•</span>
                  <div>
                    <p className="text-sm text-white">Anwani ya IP (kwa ujumla)</p>
                    <p className="text-xs text-gray-500">Approximate IP address</p>
                  </div>
                </li>
              </ul>
              <p className="mt-4 text-sm text-gray-400 border-t border-white/10 pt-3">
                See{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary-400 hover:text-secondary-300 underline"
                >
                  Google's Privacy Policy
                </a>{' '}
                for details on how Google handles this data.
              </p>
            </div>
          </section>

          {/* 4. Third-Party Services */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              4. Huduma za Wahusika Wengine / Third-Party Services
            </h2>
            <div className="space-y-3">
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between bg-white/5 hover:bg-white/10 transition-colors rounded-xl p-5 border border-white/10 group"
              >
                <div>
                  <p className="text-white font-semibold text-sm group-hover:text-secondary-400 transition-colors">
                    Google AdMob
                  </p>
                  <p className="text-gray-500 text-xs mt-0.5">Matangazo / Advertising</p>
                </div>
                <span className="text-gray-600 group-hover:text-secondary-400 transition-colors text-xs">
                  Privacy Policy ↗
                </span>
              </a>
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between bg-white/5 hover:bg-white/10 transition-colors rounded-xl p-5 border border-white/10 group"
              >
                <div>
                  <p className="text-white font-semibold text-sm group-hover:text-secondary-400 transition-colors">
                    Google Fonts
                  </p>
                  <p className="text-gray-500 text-xs mt-0.5">Maandishi / Typography</p>
                </div>
                <span className="text-gray-600 group-hover:text-secondary-400 transition-colors text-xs">
                  Privacy Policy ↗
                </span>
              </a>
            </div>
          </section>

          {/* 5. Children */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              5. Watoto / Children
            </h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 space-y-3">
              <p className="text-sm">
                Programu hii haikusudiwi watoto chini ya miaka 13. Hatukusanyi data ya watoto
                kwa makusudi.
              </p>
              <p className="text-gray-400 text-sm border-t border-white/10 pt-3">
                This app is not directed at children under 13. We do not knowingly collect
                children's data.
              </p>
            </div>
          </section>

          {/* 6. Changes */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              6. Mabadiliko / Changes
            </h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 space-y-3">
              <p className="text-sm">
                Tunaweza kubadilisha sera hii. Mabadiliko yatatangazwa kwenye ukurasa huu.
              </p>
              <p className="text-gray-400 text-sm border-t border-white/10 pt-3">
                We may update this policy. Changes will be posted on this page.
              </p>
            </div>
          </section>

          {/* 7. Contact */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">
              7. Wasiliana Nasi / Contact Us
            </h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <p className="text-white font-semibold mb-3">Sala Takatifu</p>
              <p className="text-sm">
                Barua pepe / Email:{' '}
                <a
                  href="mailto:salatakatifu@gmail.com"
                  className="text-secondary-400 hover:text-secondary-300"
                >
                  salatakatifu@gmail.com
                </a>
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default SalaTakatifuPrivacyPage;
